import { HeroAboutSection } from "@/components/heros/section-hero-about";
import { AprimoramosSection } from "@/components/sections/section-aprimoramento";
import { BannerSection } from "@/components/sections/section-banner";

import { InovamosSection } from "@/components/sections/section-inovamos";
import { PlataformaDigitalSection } from "@/components/sections/section-plataforma-digital";
import { StatsSectionClear } from "@/components/sections/section-stats-clear";
import { TestimonialSection } from "@/components/sections/section-testimonial";
import { ValoresSection } from "@/components/sections/section-valores";
import { VisionariosSection } from "@/components/sections/section-visionarios";

export default function About() {
  return (
    <div className="min-h-screen bg-n-bg-1">
      <HeroAboutSection />

      <PlataformaDigitalSection />

      {/* Inovamos section */}
      <InovamosSection />

      {/* Visionários desde 2010 */}
      <VisionariosSection />

      {/* Aprimoramento */}
      <AprimoramosSection />

      {/* Stats Section */}
      <StatsSectionClear />

      {/* Valores */}
      <ValoresSection />

      {/* Testimonial section */}
      <TestimonialSection />

      {/* Section team */}
      {/* <TeamSection /> */}

      {/* Banner de cotação */}
      <BannerSection title="Faça agora uma cotação e agende o transporte do seu veículo !" />
    </div>
  );
}
